





























import { Component, Vue } from 'vue-property-decorator'
import RecommendApplication from '../../components/recommend/RecommendApplication.vue'
import RecommendProduct from '../../components/recommend/RecommendProduct.vue'
import RecommendModal from '../../components/recommend/RecommendModal.vue'
import SilverEgg, { SpecType } from '../../modules/silverEgg/SilverEgg'
import { RecommendItem } from '../../modules/silverEgg/RecommendResponse'
import { createCustomEvent } from '@/modules/CustomEvent'

@Component({
  components: {
    RecommendApplication,
    RecommendProduct,
    RecommendModal
  }
})
export default class RecommendShowModal extends Vue {
  // ------------------------------------------------------------------------------------------------
  // data
  private isShowModal = false
  private recommendProduct: RecommendItem[] = []
  private recommendApplication: RecommendItem[] = []

  private se: SilverEgg = new SilverEgg(
    drupalSettings.vueComponent.silveregg.domain,
    drupalSettings.vueComponent.silveregg.specId
  )

  // -------------------------------------------------------------------------------------------------------------------
  // hooks

  private async mounted() {
    // cookie判定
    const result = await this.se.getRecommendID()
    if (result) {
      // 製品情報取得
      this.getProduct()
      // アプリケーション情報取得
      this.getApplication()
    }
  }

  // ------------------------------------------------------------------------------------------------
  // computed

  /**
   * 製品のおすすめの表示可否
   */
  private get isShowProductRecommend(): boolean {
    return this.recommendProduct.length > 0
  }

  /**
   * アプリケーションのおすすめの表示可否
   */
  private get isShowApplicationRecommend(): boolean {
    return this.recommendApplication.length > 0
  }

  /**
   * おすすめの表示可否
   */
  private get isShowRecommend(): boolean {
    return this.isShowProductRecommend || this.isShowApplicationRecommend
  }

  // ------------------------------------------------------------------------------------------------
  // method

  /**
   * 製品レコメンド取得処理
   */
  private async getProduct() {
    this.recommendProduct = await this.se.fetchRecommend(
      'productpage',
      'product',
      drupalSettings.vueComponent.common.nid
    )
  }

  /**
   * アプリケーションレコメンド取得処理
   */
  private async getApplication() {
    this.recommendApplication = await this.se.fetchRecommend(
      'productpage',
      'application'
    )
  }

  /**
   * レコメンドクリック時処理
   */
  private async select(item: RecommendItem, recommendType: SpecType) {
    await this.se.sendLinkClickEventToGtm(item, 'productpage', recommendType)

    // GTM送信後、各クリック処理を呼び出す
    if (recommendType === 'application') {
      // レコメンドのURLを引数にCallDownloadLinkに処理を移す
      createCustomEvent('start-pdf-download', { url: item.ctUrl })
    } else {
      window.location.href = item.ctUrl
    }
  }
}
